import { cloneDeep } from "lodash";

const SET_DEVICE_CHANGE_HISTORY = "app/deviceChangeHistory/SET_DEVICE_CHANGE_HISTORY";
const RESET_DEVICE_CHANGE_HISTORY = "app/deviceChangeHistory/RESET_DEVICE_CHANGE_HISTORY";
const SET_LOADING = "app/deviceChangeHistory/SET_LOADING";
const SET_REFRESH = "app/deviceChangeHistory/SET_REFRESH";
const SET_ERROR = "app/deviceChangeHistory/SET_ERROR";

const initialState = {
  deviceChangeHistory: null,
  loading: false,
  refresh: false,
  error: null
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_DEVICE_CHANGE_HISTORY: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        deviceChangeHistory: action.payload
      };
    }

    case RESET_DEVICE_CHANGE_HISTORY: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        deviceChangeHistory: null
      };
    }

    case SET_REFRESH: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        refresh: action.payload
      };
    }

    case SET_LOADING: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        loading: action.payload
      };
    }

    case SET_ERROR: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        error: action.payload
      };
    }

    default: {
      return state;
    }
  }
}

export const setDeviceChangeHistory = (deviceChangeHistory) => ({
  type: SET_DEVICE_CHANGE_HISTORY,
  payload: deviceChangeHistory
});

export const resetDeviceChangeHistory = () => ({
  type: RESET_DEVICE_CHANGE_HISTORY
});

export const setLoading = (loading) => ({ type: SET_LOADING, payload: loading });

export const setRefresh = (refresh) => ({ type: SET_REFRESH, payload: refresh });

export const setError = (error) => ({ type: SET_ERROR, payload: error });
